// Presigned links (private R2/S3 bucket) carry their auth in the query string:
// X-Amz-Signature is computed over every parameter, so adding one (a `?v=`
// cache-buster) makes the bucket reject the request with 403. They are also
// unique per API response already, so there is nothing to bust.
export const isPresignedUrl = (url: string | null | undefined): boolean =>
  !!url && /[?&]X-Amz-(Signature|Credential)=/i.test(url)

// The path part of a URL, without ?query and #hash - what a file extension
// must be read from. `photo.png?X-Amz-...` would otherwise read as
// `png?X-Amz-...` and not be recognised as an image.
export const urlPath = (url: string | null | undefined): string => {
  if (!url) return ''
  return url.split('#', 1)[0].split('?', 1)[0]
}

export function appendQueryParam(
  url: string | null | undefined,
  key: string,
  value: string | number | null | undefined
): string {
  if (!url) return ''
  if (value === null || value === undefined || value === '') return url

  // Don’t modify non-network URLs.
  if (url.startsWith('blob:') || url.startsWith('data:')) return url

  // Never touch a signed URL - any extra parameter breaks its signature.
  if (isPresignedUrl(url)) return url

  const [base, hash = ''] = url.split('#', 2)
  const sep = base.includes('?') ? '&' : '?'
  const next = `${base}${sep}${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
  return hash ? `${next}#${hash}` : next
}
